import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from 'src/environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from "rxjs/operators";
import { PortfolioInsuranceInterface, PortfolioInsuranceMotorInterface } from "../models/portfolio-insurance.interface";

@Injectable({ providedIn: 'root' })
export class InsuranceService {

    constructor(private http: HttpClient) { }
    private strorageDetails: BehaviorSubject<any> = new BehaviorSubject(null);
    data$ = this.strorageDetails.asObservable();

    private strorageListTypeMotor: BehaviorSubject<any> = new BehaviorSubject(null);
    listTypeMotor$ = this.strorageDetails.asObservable();

    getList(body): Observable<PortfolioInsuranceInterface> {
        return this.http.post<PortfolioInsuranceInterface>(environment.endpointBackend + '/api/portfolio/list', body).pipe(
            map(
                response => {
                    try {
                        return response
                    } catch (error) {
                        return error
                    }
                }
            )
        )
    }
 
}